/* eslint-disable import/prefer-default-export */
import { ICategory, TCategoriesTree } from '@features/categories/typescript';
import { IBreadcrumbStep, TBreadcrumbHref } from '@typescript/index';
import { searchCategoryTree } from '@utils/categoriesData';
export const createBreacrumbs = (home: string, categoriesTree: TCategoriesTree, categoryId: number, mainCategory: string | string[] | undefined, pathname = '/[mainCategory]/[...slug]', appendSteps: IBreadcrumbStep[] = []): IBreadcrumbStep[] => {
  const homeStep = {
    name: home,
    href: {
      pathname: '/'
    },
    id: 0
  } as IBreadcrumbStep;
  const arrSteps: ICategory[] = [];
  const siblings: Record<number, IBreadcrumbStep[]> = {};
  if (!categoriesTree || Object.keys(categoriesTree).length === 0) {
    return [homeStep, ...(appendSteps || [])];
  }
  const buildSteps = (id = categoryId) => {
    const categories: ICategory[] = Object.values(categoriesTree);
    const foundCategory = searchCategoryTree(categories, id);
    if (foundCategory) {
      arrSteps.push(foundCategory);
    }
    if (foundCategory?.parent_id) {
      const parent = searchCategoryTree(categories, foundCategory.parent_id);
      const categorySiblings: ICategory[] = parent?.children && !Array.isArray(parent?.children) ? Object.values(parent.children) : [];
      if (siblings) {
        let mainCategoryObject = mainCategory;
        if (!mainCategoryObject) {
          if (parent?.parent_id) {
            const grandParent = searchCategoryTree(categories, parent.parent_id);
            mainCategoryObject = grandParent?.slug;
          } else {
            mainCategoryObject = parent?.slug;
          }
        }
        const breadcrumbSiblings = categorySiblings.map(sibling => {
          const newSlug = sibling.pageSlug?.split('/');
          newSlug.shift();
          let href: TBreadcrumbHref = {
            pathname: '/[mainCategory]/[...slug]',
            query: {
              mainCategory: mainCategoryObject
            }
          };
          if (newSlug?.length) {
            href = {
              ...href,
              query: {
                ...href.query,
                slug: newSlug
              },
              pathname
            };
          }
          return {
            behaviour: sibling.behaviour,
            position: sibling.position,
            name: sibling.name,
            id: sibling.id,
            href
          };
        });

        // NOTE: sort siblings by position
        breadcrumbSiblings.sort((a, b) => a.position - b.position);
        const categoriesOnly = breadcrumbSiblings.filter(sibling => sibling.behaviour === 'category');
        const collectionsOnly = breadcrumbSiblings.filter(sibling => sibling.behaviour === 'collection');
        const rest = breadcrumbSiblings.filter(sibling => sibling.behaviour !== 'category' && sibling.behaviour !== 'collection');
        siblings[id] = [...collectionsOnly, ...categoriesOnly, ...rest];
      }
      buildSteps(foundCategory.parent_id);
    }
  };
  buildSteps();

  // If no steps were found, ensure we still return at least the home step
  if (arrSteps.length === 0) {
    return [homeStep, ...(appendSteps || [])];
  }
  const steps = arrSteps.reverse().map((cat, index) => {
    const {
      name,
      id
    } = cat;
    const newSlug = cat.pageSlug?.split('/');
    newSlug.shift();
    let mainCategoryObject = mainCategory;
    if (!mainCategoryObject) {
      mainCategoryObject = arrSteps[0].slug;
    }
    let href: TBreadcrumbHref = {
      pathname: '/[mainCategory]/[...slug]',
      query: {
        mainCategory: mainCategoryObject
      }
    };
    if (newSlug?.length) {
      href = {
        ...href,
        query: {
          ...href.query,
          slug: newSlug
        },
        pathname
      };
    }
    return {
      name,
      href: index !== 0 ? href : '',
      id,
      siblings: siblings[id] || []
    };
  });
  return [homeStep, ...steps, ...(appendSteps || [])];
};